import React, {memo} from "react";
import {makeStyles} from "@material-ui/core/styles";

const useStyles = makeStyles({
    root: {
        width: 220
    },
    img: {
        width: '100%',
        height: 'auto'
    }
})

const SocialWallPhoto = ({item}) => {

    const classes = useStyles()

    return (<div className={classes.root}>
        <img alt={''} src={item.data} className={classes.img}/>
    </div>)
}

export default memo(SocialWallPhoto)